module.exports = __webpack_public_path__ + "img/surf-giveaways-logo--dark.5610e1b7.svg";